import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { withTranslation } from 'react-i18next';
import commonStyles from '../../Common/commonStyles';
import defaultTextValue from '../../Common/defaultTextValue';
const styles = StyleSheet.create({
    detailsView: {
        display: 'flex',
        flexDirection: 'row',
        marginHorizontal: commonStyles.marginHorizontal,
        marginBottom: '4%',
    },
    columnTitle: Object.assign(Object.assign({}, commonStyles.fontS), { paddingBottom: 4, borderBottom: '1px solid #b8b8b8', marginBottom: 5 }),
    detailsColumn: {
        width: '50%',
        marginRight: '5%',
    },
    detail: {
        marginLeft: 5,
        marginBottom: 5,
    },
    detailTitle: Object.assign({}, commonStyles.fontXS),
    detailDescription: Object.assign({}, commonStyles.fontXS),
});
export function Detail({ title, description, width }) {
    return (React.createElement(View, { style: [styles.detail, { width, maxWidth: width }] },
        React.createElement(Text, { style: styles.detailTitle }, defaultTextValue(title)),
        React.createElement(Text, { style: styles.detailDescription }, defaultTextValue(description))));
}
function Details({ admins, brand, category, code, designers, patternMaker, season, 
// specificationMemberProduction,
t, title, }) {
    return (React.createElement(View, { style: styles.detailsView },
        React.createElement(View, { style: styles.detailsColumn },
            React.createElement(Text, { style: styles.columnTitle }, t('basic_informations')),
            React.createElement(Detail, { title: t('common:name'), description: title }),
            React.createElement(Detail, { title: t('category'), description: category }),
            React.createElement(Detail, { title: t('brand'), description: brand }),
            React.createElement(Detail, { title: t('season'), description: season }),
            React.createElement(Detail, { title: t('item_code'), description: code })),
        React.createElement(View, { style: styles.detailsColumn },
            React.createElement(Text, { style: styles.columnTitle }, t('project_team')),
            React.createElement(Detail, { title: t('specification:specification_member_ADMIN'), description: admins }),
            React.createElement(Detail, { title: t('specification:specification_member_DESIGNER'), description: designers }),
            React.createElement(Detail, { title: t('specification:specification_member_PATTERNER'), description: patternMaker }))));
}
export default withTranslation('specification')(Details);
